import * as React from 'react';
import './styles.scss';

const Body: React.FunctionComponent<{ children: React.ReactNode }> = (props) => {
  return <div className={'body'}>{props.children}</div>;
};

Body.displayName = 'Body';

export default Body;
